import { render, staticRenderFns } from "./MenuCategoryIcon.vue?vue&type=template&id=4f3ab384&scoped=true&"
import script from "./MenuCategoryIcon.vue?vue&type=script&lang=js&"
export * from "./MenuCategoryIcon.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategoryIcon.vue?vue&type=style&index=0&id=4f3ab384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ab384",
  null
  
)

export default component.exports